import { KitType } from '@repo/types';
import type {
  Gate,
  GateSharedProps,
  GateViewerRole,
} from 'contexts/analytics/events/gates';
import { UserRoles } from 'store/user';

export function getGateViewerRole(
  impersonateId: string | null | undefined,
  roles: string[] = [],
): GateViewerRole {
  if (!impersonateId) return 'user';
  return roles.includes(UserRoles.PRACTITIONER)
    ? 'prac_impersonation'
    : 'specialist_impersonation';
}

export function getGateExperience({
  gutBodyConnectionsEnabled,
  isConditionDetail,
  kitType,
}: {
  gutBodyConnectionsEnabled: boolean;
  isConditionDetail: boolean;
  kitType: KitType;
}): GateSharedProps['experience'] {
  const showsGutBodyConnections =
    gutBodyConnectionsEnabled &&
    (isConditionDetail || kitType === KitType.STOOL);
  return showsGutBodyConnections ? 'gut_body_connections' : 'legacy_conditions';
}

export function getGateEntrySurface({
  gate,
  isConditionDetail,
  isInitialEntry,
  fromHomeCard,
}: {
  gate: Gate;
  isConditionDetail: boolean;
  isInitialEntry: boolean;
  fromHomeCard: boolean;
}): GateSharedProps['entry_surface'] {
  if (gate === 'gate_2' || isConditionDetail) return 'condition_detail';
  if (fromHomeCard) return 'home_card';
  return isInitialEntry ? 'deep_link' : 'conditions_page';
}

export const secondsSince = (start: number) =>
  Math.round((Date.now() - start) / 1000);
